import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { Box, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { DefaultCard } from "../../assets/styled-components/card";
import Attachment from "../commoncomponents/Attachments";
import VerticalLinearStepper from "../commoncomponents/stepper";
import AssetSpecification from "./AssetSpecification";
import BasicDetails from "./BasicDetails";
import PurchaseDetails from "./PurchaseDetails";
import PageTitle from '../commoncomponents/PageTitle';
import { useLocation } from 'react-router-dom';

function AssetMain() {
  //state to check user choose to edit
  const selectedGridData = useSelector((state) => state.gridValues.selectedGridData);
  const { mandatoryFieldsBasicDetails, mandatoryFieldsAssetSpecification, mandatoryFieldsPurchaseDetails } = useSelector((state) => state.mandatoryFields);
  const assetCategoryType = useSelector((state) => state?.serviceType?.assetType);
  const [page, setPage] = useState("Basic Details");
  const [mandatoryBasicDetails, setMandatoryBasicDetails] = useState(mandatoryFieldsBasicDetails);
  const [mandatoryAssetSpecification, setMandatoryAssetSpecification] = useState(mandatoryFieldsAssetSpecification);
  const [mandatoryPurchaseDetails, setMandatoryPurchaseDetails] = useState(mandatoryFieldsPurchaseDetails);
  const location = useLocation();
  const mode = location.state?.assetMode;

  const pageInfo = mode === "Edit" ? "Edit" : "Create";
  const [authorizeTick, setAuthorizeTick] = useState(0);
  const percentage = selectedGridData?.values?.processingpercentage;

  const pageTitle =
    assetCategoryType === "/assetsFEM"
      ? `${pageInfo} Asset Register - FEMS`
      : `${pageInfo} Asset Register - BEMS`;

  useEffect(() => {
    if (mandatoryFieldsBasicDetails) {
      setMandatoryBasicDetails(mandatoryFieldsBasicDetails)
    }
    if (mandatoryFieldsAssetSpecification) {
      setMandatoryAssetSpecification(mandatoryFieldsAssetSpecification)
    }
    if (mandatoryFieldsPurchaseDetails) {
      setMandatoryPurchaseDetails(mandatoryFieldsPurchaseDetails)
    }
  }, [mandatoryFieldsBasicDetails, mandatoryFieldsAssetSpecification, mandatoryFieldsPurchaseDetails])


  const buttonAttributes = [
    {
      currentPageName: "Basic Details",
      setPage: setPage,
      cancelButtonName: "Cancel",
      continueButtonName: "Continue to Asset Specification",
      backButtonName: "",
      backButton: false,
      nextPageName: "Asset Specification",
      previousPageName: "",
      mainHeader: "Basic Details",
      requiredButton: true,
      subHeader:
        "Please provide basic details about the facility equipment you are registering to help us manage and maintain it effectively.",
      secondSubHeaderAndDate: false,
    },
    {
      currentPageName: "Asset Specification",
      setPage: setPage,
      cancelButtonName: "Cancel",
      continueButtonName: "Continue to Purchase Details",
      backButtonName: "Back",
      backButton: true,
      nextPageName: "Purchase/Warranty Details",
      previousPageName: "Basic Details",
      requiredButton: true,
      mainHeader: "Asset Specification",
      subHeader:
        "By detailing the specifications of each asset, this section enhances organizational by providing a centralized location for critical information.",
      secondSubHeaderAndDate: false,
    },
    {
      currentPageName: "Purchase/Warranty Details",
      setPage: setPage,
      cancelButtonName: "Cancel",
      continueButtonName: "Continue to Attachments",
      backButtonName: "Back",
      backButton: true,
      nextPageName: "Attachments",
      previousPageName: "Asset Specification",
      requiredButton: true,
      mainHeader: "Purchase Details",
      subHeader:
        "Accurate record-in this section ensures comprehensive management of your assets, facilitating informed decision-making and efficient maintenance practices.",
      secondSubHeaderAndDate: false,
    },
    {
      currentPageName: "Attachments",
      setPage: setPage,
      cancelButtonName: "Cancel",
      continueButtonName: "Authorize",
      backButtonName: "Back",
      backButton: true,
      nextPageName: "",
      previousPageName: "Purchase/Warranty Details",
      mainHeader: "Attachments",
      subHeader: "Please attach the required files.",
      secondSubHeaderAndDate: false,
      requiredButton: false,
    },
  ];

  const renderPageContent = () => {
    switch (page) {
      case "Basic Details":
        return (
          <BasicDetails
            page={page}
            setPage={setPage}
            buttonAttributes={buttonAttributes}
          />
        );
      case "Asset Specification":
        return (
          <AssetSpecification
            page={page}
            setPage={setPage}
            buttonAttributes={buttonAttributes}
          />
        );
      case "Purchase/Warranty Details":
        return (
          <PurchaseDetails
            page={page}
            setPage={setPage}
            buttonAttributes={buttonAttributes}
          />
        );
      case "Attachments":
        return (
          <Attachment
            page={page}
            setPage={setPage}
            buttonAttributes={buttonAttributes}
            setAuthourizeTick={setAuthorizeTick}
          />
        );
      default:
        return null;
    }
  };

  const renderMandatoryFields = () => {
    let mandatoryFieldsFind = [];

    switch (page) {
      case "Basic Details":
        mandatoryFieldsFind = mandatoryBasicDetails;
        break;
      case "Asset Specification":
        mandatoryFieldsFind = mandatoryAssetSpecification;
        break;
      case "Purchase/Warranty Details":
        mandatoryFieldsFind = mandatoryPurchaseDetails;
        break;
      case "Attachments":
        mandatoryFieldsFind = [];
        break;
      default:
        mandatoryFieldsFind = [];
    }

    // Check if mandatoryFieldsFind is undefined before mapping
    if (mandatoryFieldsFind === undefined) {
      return null;
    }

    return mandatoryFieldsFind.map((field, index) => (
      <Grid
        key={index}
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          marginBottom: "5px",
        }}
      >
        {field.isVisible === true ?
          <>
            {field.valueFilled === false ? <HighlightOffRoundedIcon
              color="disabled"
              sx={{ fontSize: 16, marginRight: "5px" }}
            /> :
              <CheckCircleOutlineIcon
                color="success"
                sx={{ fontSize: 16, marginRight: "5px" }}
              />}
            <Typography
              variant='labelSm'
              color={'text.grey'}
              component={'label'}
              sx={{
                fontSize: {
                  xs: '1rem', // Small size for extra small screens
                  sm: '0.875rem', // Slightly larger for small screens
                  md: '1rem', // Default size for medium screens and up
                },
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: {
                  xs: '150px', // Maximum width for extra small screens
                  sm: '200px', // Maximum width for small screens
                  md: '250px', // Maximum width for medium screens
                },
              }}
            >
              {field.type}
            </Typography>
          </>
          :
          null
        }
      </Grid>
    ));
  };


  const mapPercentageToLabelId = (percentage) => {
    if (percentage === 100) return 4;
    if (percentage === 75) return 3;
    if (percentage === 50) return 2;
    if (percentage === 25) return 1;
    return 0; // Default for anything else
  };

  const checkSteppsForTC = (percentage) => {
    const stepsForAsset = [
      { label: "Basic Details", key: "Basic Details", value: "0", labelId: mapPercentageToLabelId(percentage || "") },
      { label: "Asset Specification", key: "Asset Specification", value: "25", labelId: mapPercentageToLabelId(percentage || "") },
      { label: "Purchase Details", key: "Purchase/Warranty Details", value: "50", labelId: mapPercentageToLabelId(percentage || "") },
      { label: "Attachments", key: "Attachments", value: "75", labelId: mapPercentageToLabelId(percentage || "") + (authorizeTick || 0) },
    ];

    if (percentage) {
      const updatedSteps = stepsForAsset?.map((item) => ({ ...item, value: `${percentage}` }));
      return updatedSteps;
    }
    return stepsForAsset;
  }



  return (
    <>
      <PageTitle title={pageTitle} />
      <Box mt={{ xs: 1, sm: 2 }}>
        <Grid container sx={{ display: "flex" }} spacing={2}>
          {/*  left section  */}
          <Grid item xs={12} sm={3.4} md={2.2}>
            <DefaultCard sx={{ height: "100%" }}>
              <Box pb={{ xs: 1, sm: 5 }}>
                <VerticalLinearStepper page={page} steps={checkSteppsForTC(percentage)} />
                <Box>
                  {page === "Attachments" ? null : page ===
                    "Tc Others Details" ? null : (
                    <>
                      <Divider variant="middle" sx={{ marginBottom: "10%" }} />
                      {page === "Basic Details" && (
                        <Typography color='text.primary' mb={2} >
                          You can go to the next step once you complete these
                          following mandatory input fields
                        </Typography>
                      )}
                      {page === "Asset Specification" && (mandatoryFieldsAssetSpecification.some(field => field.isVisible === true)) && (
                        <Typography color='text.primary' mb={2} >
                          You can go to the next step once you complete these
                          following mandatory input fields
                        </Typography>
                      )}
                      {page === "Purchase/Warranty Details" && (mandatoryFieldsPurchaseDetails.some(field => field.isVisible === true)) && (
                        <Typography color='text.primary' mb={2} >
                          You can go to the next step once you complete these
                          following mandatory input fields
                        </Typography>
                      )}
                    </>
                  )}
                  {renderMandatoryFields()}
                </Box>
              </Box>
            </DefaultCard>
          </Grid>
          {/*  right section  */}
          <Grid item xs={12} sm={8.6} md={9.8}>
            <DefaultCard sx={{ height: "100%" }}>
              {renderPageContent()}
            </DefaultCard>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default AssetMain;
